<template>
    <div class="trading-desk-container portfolio-wrapper">
        <v-layout column wrap fill-height="true">
            <div v-if="wineListLoading" class="loading-screen">
                <v-img class="loading-gif" src="../assets/loading.gif"></v-img>
            </div>
            <div v-else>
                <div class="trading-desk-container1" v-if="!isLogged">
                    <div class="wine-market-wrapper">
                        <h3>My portfolio</h3>
                        <div class="no-fav">
                            <div>Join Vindome to start building your collection of favourite wines</div>
                            <button class="btn-primary goto-market-btn" v-on:click="() => goToLogin()">Join Vindome
                            </button>
                        </div>
                    </div>
                </div>

                <div class="trading-desk-container1" v-if="isLogged">
                    <div class="wine-market-wrapper">
                        <div class="gift-btn" v-on:click="giftModal=true" v-if="showGift">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M15.7428 3.62427C15.9191 3.26801 15.9999 2.88239 15.9999 2.50973C15.9999 1.33445 15.1438 0 13.5569 0C12.5556 0 11.6709 0.601562 11.1325 1.04487C10.5878 1.49337 10.1877 1.95816 10.0645 2.10828L9.99997 2.17884L9.93545 2.10828C9.81219 1.95816 9.41217 1.49337 8.86745 1.04487C8.32904 0.601562 7.44433 0 6.44303 0C4.85618 0 3.99999 1.33445 4 2.50973C4 2.88239 4.08082 3.26801 4.25716 3.62427H1C0.447715 3.62427 0 4.07198 0 4.62427V8.08285C0 8.63514 0.447715 9.08285 1 9.08285V9.08285V19C1 19.5523 1.44772 20 2 20H18C18.5523 20 19 19.5523 19 19V9.08285V9.08285C19.5523 9.08285 20 8.63514 20 8.08285V4.62427C20 4.07198 19.5523 3.62427 19 3.62427H15.7428ZM6.12223 2.83692C6.187 2.90126 6.35322 3.01797 6.7469 3.01797H8.06172C7.93326 2.8874 7.7747 2.73697 7.59676 2.59047C7.11735 2.19575 6.70288 2.00148 6.44303 2.00148C6.28667 2.00148 6.19705 2.05709 6.13305 2.13046C6.05538 2.21949 6 2.35865 6 2.50972C6 2.65458 6.04956 2.76473 6.12223 2.83692ZM13.8777 2.83692C13.8129 2.90126 13.6467 3.01797 13.253 3.01797H11.9382C12.0667 2.8874 12.2252 2.73697 12.4032 2.59047C12.8826 2.19575 13.2971 2.00148 13.5569 2.00148C13.7133 2.00148 13.8029 2.05709 13.8669 2.13046C13.9446 2.21949 13.9999 2.35865 13.9999 2.50972C13.9999 2.65458 13.9504 2.76473 13.8777 2.83692ZM3 18.1805V9.08285H7L7 18.1805H3ZM7 5.4438L7 7.26332H2V5.4438H7ZM13 9.08285H17V18.1805H13L13 9.08285ZM18 7.26332H13V5.4438H18V7.26332ZM9 18.1805L9 5.4438H11L11 18.1805H9Z"
                                      fill="#004F7F"/>
                            </svg>
                            {{ $t('apply-gift') }}
                        </div>
                        <v-tabs v-model="portfolioSelectedTab" class="portfolio-tabs">
                            <v-tab key="performance" href="#performance">{{ $t('performance') }}</v-tab>
                            <v-tab key="investments" href="#investments">{{ $t('my-investments') }}</v-tab>
                            <v-tab key="soldwines" href="#soldwines">{{ $t('my-sold-wines') }}</v-tab>
                            <v-tab key="bidsoffers" href="#bidsoffers">{{ $t('my-bids') }}</v-tab>
                        </v-tabs>
                        <v-tabs-items :value="portfolioSelectedTab">
                            <v-tab-item value="performance">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row" v-if="wineList.length > 0">
                                            <div class="col-8">
                                                <InvestmentCharts></InvestmentCharts>
                                            </div>
                                            <div class="col-4">
                                                <YourWines v-bind:selectedRegionTab="selectedRegionTab"
                                                           v-bind:regionList="regionList"
                                                           v-bind:colourList="colourList"></YourWines>
                                                <WineCellar
                                                    v-on:openVirtualCellarModal="openVirtualCellarModal"></WineCellar>
                                            </div>
                                        </div>
                                        <div class="row" v-if="wineList.length > 0">
                                            <div class="col-12">
                                                <Transactions
                                                    v-bind:getInvesmentsTransactionsLength="getInvesmentsTransactionsLength"
                                                    v-bind:getInvestmentsTransactions="getInvestmentsTransactions"></Transactions>
                                            </div>
                                        </div>
                                        <div class="row" v-if="wineList.length === 0">
                                            <div class="col-12">
                                                <div class="no-investments-wrapper">
                                                    <svg width="172" height="168" viewBox="0 0 172 168" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                              d="M42.3217 15.1198C40.6366 15.1198 38.9917 15.2849 37.4018 15.5995C36.4916 15.7795 35.6078 15.1876 35.4277 14.2774C35.2476 13.3672 35.8395 12.4834 36.7497 12.3033C38.5532 11.9466 40.4165 11.7598 42.3217 11.7598H49.6017C50.5296 11.7598 51.2817 12.5119 51.2817 13.4398C51.2817 14.3676 50.5296 15.1198 49.6017 15.1198H42.3217ZM62.4817 13.4398C62.4817 12.5119 63.2339 11.7598 64.1617 11.7598H78.7217C79.6496 11.7598 80.4017 12.5119 80.4017 13.4398C80.4017 14.3676 79.6496 15.1198 78.7217 15.1198H64.1617C63.2339 15.1198 62.4817 14.3676 62.4817 13.4398ZM91.6017 13.4398C91.6017 12.5119 92.3539 11.7598 93.2817 11.7598H107.842C108.77 11.7598 109.522 12.5119 109.522 13.4398C109.522 14.3676 108.77 15.1198 107.842 15.1198H93.2817C92.3539 15.1198 91.6017 14.3676 91.6017 13.4398ZM120.722 13.4398C120.722 12.5119 121.474 11.7598 122.402 11.7598H129.682C131.587 11.7598 133.45 11.9466 135.254 12.3033C136.164 12.4834 136.756 13.3672 136.576 14.2774C136.396 15.1876 135.512 15.7795 134.602 15.5995C133.012 15.2849 131.367 15.1198 129.682 15.1198H122.402C121.474 15.1198 120.722 14.3676 120.722 13.4398ZM28.7828 17.0327C29.299 17.8037 29.0924 18.8471 28.3214 19.3633C25.5726 21.2036 23.2056 23.5706 21.3653 26.3194C20.8491 27.0904 19.8056 27.297 19.0346 26.7808C18.2636 26.2647 18.057 25.2212 18.5732 24.4502C20.6578 21.3364 23.3384 18.6559 26.4522 16.5713C27.2232 16.0551 28.2666 16.2617 28.7828 17.0327ZM143.221 17.0327C143.737 16.2617 144.78 16.0551 145.551 16.5713C148.665 18.6559 151.346 21.3364 153.43 24.4502C153.946 25.2212 153.74 26.2647 152.969 26.7808C152.198 27.297 151.154 27.0904 150.638 26.3194C148.798 23.5706 146.431 21.2036 143.682 19.3633C142.911 18.8471 142.704 17.8037 143.221 17.0327ZM16.2794 33.4257C17.1896 33.6058 17.7815 34.4896 17.6014 35.3998C17.2869 36.9897 17.1217 38.6346 17.1217 40.3198V47.5998C17.1217 48.5276 16.3696 49.2798 15.4417 49.2798C14.5139 49.2798 13.7617 48.5276 13.7617 47.5998V40.3198C13.7617 38.4145 13.9485 36.5512 14.3053 34.7478C14.4854 33.8376 15.3692 33.2457 16.2794 33.4257ZM155.724 33.4258C156.634 33.2457 157.518 33.8376 157.698 34.7478C158.055 36.5512 158.242 38.4145 158.242 40.3198V47.5998C158.242 48.5276 157.49 49.2798 156.562 49.2798C155.634 49.2798 154.882 48.5276 154.882 47.5998V40.3198C154.882 38.6346 154.717 36.9897 154.402 35.3998C154.222 34.4896 154.814 33.6058 155.724 33.4258ZM15.4417 60.4798C16.3696 60.4798 17.1217 61.2319 17.1217 62.1598V76.7198C17.1217 77.6476 16.3696 78.3998 15.4417 78.3998C14.5139 78.3998 13.7617 77.6476 13.7617 76.7198V62.1598C13.7617 61.2319 14.5139 60.4798 15.4417 60.4798ZM156.562 60.4798C157.49 60.4798 158.242 61.2319 158.242 62.1598V76.7198C158.242 77.6476 157.49 78.3998 156.562 78.3998C155.634 78.3998 154.882 77.6476 154.882 76.7198V62.1598C154.882 61.2319 155.634 60.4798 156.562 60.4798ZM15.4417 89.5998C16.3696 89.5998 17.1217 90.3519 17.1217 91.2798V105.84C17.1217 106.768 16.3696 107.52 15.4417 107.52C14.5139 107.52 13.7617 106.768 13.7617 105.84V91.2798C13.7617 90.3519 14.5139 89.5998 15.4417 89.5998ZM156.562 89.5998C157.49 89.5998 158.242 90.3519 158.242 91.2798V105.84C158.242 106.768 157.49 107.52 156.562 107.52C155.634 107.52 154.882 106.768 154.882 105.84V91.2798C154.882 90.3519 155.634 89.5998 156.562 89.5998ZM15.4417 118.72C16.3696 118.72 17.1217 119.472 17.1217 120.4V127.68C17.1217 129.365 17.2869 131.01 17.6014 132.6C17.7815 133.51 17.1896 134.394 16.2794 134.574C15.3692 134.754 14.4854 134.162 14.3053 133.252C13.9485 131.448 13.7617 129.585 13.7617 127.68V120.4C13.7617 119.472 14.5139 118.72 15.4417 118.72ZM156.562 118.72C157.49 118.72 158.242 119.472 158.242 120.4V127.68C158.242 129.585 158.055 131.448 157.698 133.252C157.518 134.162 156.634 134.754 155.724 134.574C154.814 134.394 154.222 133.51 154.402 132.6C154.717 131.01 154.882 129.365 154.882 127.68V120.4C154.882 119.472 155.634 118.72 156.562 118.72ZM19.0346 141.219C19.8056 140.702 20.8491 140.909 21.3653 141.68C23.2056 144.429 25.5726 146.796 28.3214 148.636C29.0924 149.152 29.299 150.196 28.7828 150.967C28.2666 151.738 27.2232 151.944 26.4521 151.428C23.3384 149.344 20.6578 146.663 18.5732 143.549C18.057 142.778 18.2636 141.735 19.0346 141.219ZM152.969 141.219C153.74 141.735 153.946 142.778 153.43 143.549C151.346 146.663 148.665 149.344 145.551 151.428C144.78 151.944 143.737 151.738 143.221 150.967C142.704 150.196 142.911 149.152 143.682 148.636C146.431 146.796 148.798 144.429 150.638 141.68C151.154 140.909 152.198 140.702 152.969 141.219ZM35.4277 153.722C35.6078 152.812 36.4916 152.22 37.4018 152.4C38.9917 152.715 40.6366 152.88 42.3217 152.88H49.6017C50.5295 152.88 51.2817 153.632 51.2817 154.56C51.2817 155.488 50.5295 156.24 49.6017 156.24H42.3217C40.4165 156.24 38.5532 156.053 36.7497 155.696C35.8395 155.516 35.2476 154.632 35.4277 153.722ZM136.576 153.722C136.756 154.632 136.164 155.516 135.254 155.696C133.45 156.053 131.587 156.24 129.682 156.24H122.402C121.474 156.24 120.722 155.488 120.722 154.56C120.722 153.632 121.474 152.88 122.402 152.88H129.682C131.367 152.88 133.012 152.715 134.602 152.4C135.512 152.22 136.396 152.812 136.576 153.722ZM62.4817 154.56C62.4817 153.632 63.2339 152.88 64.1617 152.88H78.7217C79.6495 152.88 80.4017 153.632 80.4017 154.56C80.4017 155.488 79.6495 156.24 78.7217 156.24H64.1617C63.2339 156.24 62.4817 155.488 62.4817 154.56ZM91.6017 154.56C91.6017 153.632 92.3539 152.88 93.2817 152.88H107.842C108.77 152.88 109.522 153.632 109.522 154.56C109.522 155.488 108.77 156.24 107.842 156.24H93.2817C92.3539 156.24 91.6017 155.488 91.6017 154.56Z"
                                                              fill="black" fill-opacity="0.38"/>
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                              d="M57.8714 39.124C53.8645 40.1976 51.2413 44.0355 51.6961 48.1588L54.7998 76.2942C54.8354 76.6925 54.8794 77.0912 54.9322 77.4903L54.9331 77.4971L54.9626 77.7136L54.9635 77.7204C55.0901 78.6218 55.261 79.5242 55.4775 80.4252C54.1073 81.9935 52.8242 83.5872 51.596 85.1778C50.3297 86.8177 49.1446 88.4218 47.9895 89.9852C46.1405 92.488 44.3683 94.8869 42.4633 97.1615C39.42 100.795 36.2159 103.878 32.2711 106.048C24.1286 110.526 16.6123 111.944 11.1475 112.247C8.41401 112.399 6.19538 112.272 4.67245 112.11C3.91125 112.029 3.32477 111.939 2.93576 111.871C2.74129 111.837 2.59628 111.809 2.50359 111.789C2.45725 111.78 2.42399 111.773 2.40418 111.768L2.38548 111.764C1.48273 111.553 0.577767 112.112 0.36535 113.015C0.152839 113.918 0.712731 114.822 1.61591 115.035L2.00069 113.4C1.6159 115.035 1.6151 115.035 1.61591 115.035L1.61936 115.036L1.62413 115.037L1.6376 115.04L1.68015 115.049C1.71541 115.057 1.76439 115.068 1.82674 115.081C1.95143 115.106 2.12962 115.141 2.35843 115.181C2.81599 115.261 3.47639 115.361 4.31643 115.451C5.996 115.63 8.39737 115.765 11.3339 115.602C17.2091 115.276 25.2328 113.753 33.8903 108.992C38.3455 106.541 41.8613 103.114 45.0393 99.3188C46.993 96.986 48.8888 94.422 50.7956 91.8435C51.94 90.2958 53.0883 88.7428 54.2554 87.2313C55.0382 86.2176 55.8392 85.2084 56.6676 84.2106C61.7634 97.201 75.722 104.714 89.6834 101.798L96.7205 128.061L78.7376 132.88C77.8414 133.12 77.3096 134.041 77.5497 134.937C77.7898 135.833 78.7111 136.365 79.6073 136.125L118.819 125.618C119.715 125.378 120.247 124.457 120.007 123.561C119.766 122.665 118.845 122.133 117.949 122.373L99.966 127.191L92.9289 100.929C107.508 96.1339 116.047 80.8837 112.07 66.0395C111.804 65.048 111.489 64.0822 111.127 63.144C113.713 63.1279 116.246 63.1633 118.73 63.2093C119.43 63.2222 120.128 63.2362 120.823 63.2501C131.246 63.4583 140.98 63.6528 149.599 60.3695C158.705 56.9004 164.198 52.0985 167.424 48.0935C169.033 46.0962 170.069 44.3082 170.709 43.0002C171.029 42.3463 171.25 41.8121 171.394 41.4313C171.465 41.2408 171.518 41.0887 171.554 40.9789C171.572 40.9241 171.586 40.8798 171.596 40.8467L171.609 40.8053L171.613 40.7911L171.615 40.7855L171.615 40.7832C171.616 40.7821 171.616 40.7811 170.001 40.3196L171.616 40.7811C171.871 39.8889 171.354 38.9591 170.462 38.7042C169.572 38.45 168.645 38.9632 168.387 39.851L168.386 39.8547L168.385 39.858L168.385 39.8603C168.381 39.8721 168.374 39.8947 168.363 39.9276C168.341 39.9934 168.305 40.1005 168.25 40.2447C168.141 40.5333 167.962 40.9703 167.691 41.5239C167.149 42.6309 166.243 44.2029 164.807 45.9856C161.944 49.5407 156.936 53.9788 148.403 57.2296C140.419 60.2712 131.317 60.0936 120.661 59.8857C120.044 59.8736 119.42 59.8615 118.792 59.8498C115.848 59.7953 112.804 59.7542 109.665 59.7979L98.8307 35.4824C97.1494 31.709 92.9741 29.7182 88.9839 30.7874L57.8714 39.124ZM106.027 59.889L95.7616 36.8499C94.7528 34.5859 92.2476 33.3914 89.8535 34.0329L58.741 42.3695C56.3369 43.0137 54.763 45.3164 55.0359 47.7904L58.1435 75.9615L58.1451 75.9795C58.1766 76.3348 58.2157 76.6906 58.2628 77.0467L58.2632 77.0501L58.2909 77.253L58.2913 77.2563C58.2966 77.2936 58.3019 77.3309 58.3073 77.3682C63.7522 71.839 70.6265 66.8957 80.4735 63.9118C89.5428 61.1635 98.0756 60.1831 106.027 59.889ZM59.2034 81.3012C63.2508 94.2281 76.9912 101.769 90.4487 98.1632C104.255 94.4637 112.453 80.4543 108.824 66.9091C108.554 65.9 108.226 64.9224 107.844 63.9786L107.781 63.8232L107.78 63.8208C107.694 63.6133 107.606 63.4075 107.516 63.2033C99.3533 63.4279 90.6817 64.3292 81.4479 67.1274C71.3642 70.183 64.6176 75.411 59.2034 81.3012Z"
                                                              fill="black" fill-opacity="0.38"/>
                                                        <ellipse cx="156.56" cy="55.4395" rx="8.39999" ry="8.4"
                                                                 fill="#8E8E8E"/>
                                                    </svg>
                                                    <h2>{{ $t('no-investments') }}</h2>
                                                    <router-link to="/trading-desk">
                                                        <v-btn class="btn-primary">Explore the wines</v-btn>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-tab-item>
                            <v-tab-item value="investments">
                                <div class="row">
                                    <div class="col-12">
                                        <FilterComponent
                                            :firstRowOfFilterObjects="this.firstRowOfInvestmentsFilterObjects"
                                            :secondRowOfFilterObjects="this.secondRowOfInvestmentsFilterObjects"
                                            :filtersObj="this.filtersInvestmentsObj"
                                            :onApplyFilters="this.onApplyInvestmentsFilters"
                                            :onResetFilters="this.onResetInvestmentsFilters"
                                        />

                                        <v-flex class="my-investments">
                                            <div class="investments-item">
                                                <div class="investments-label">{{ $t('initial-investment') }}</div>
                                                <div class="bold">{{
                                                        newPortfolioSummary.investmentAmount ? formatPrice(newPortfolioSummary.investmentAmount.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.')) : 0
                                                    }}
                                                </div>
                                            </div>
                                            <div class="investments-item">
                                                <div class="investments-label">{{ $t('market-value') }}</div>
                                                <div class="bold">{{
                                                        newPortfolioSummary.marketValue ? formatPrice(newPortfolioSummary.marketValue.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.')) : 0
                                                    }}
                                                </div>
                                            </div>
                                            <div class="investments-item investment-item-performance">
                                                <div class="investments-label">{{ $t('performance') }}</div>
                                                <div class="rate-wrapper">
                                                    <div class="bold">{{
                                                            newPortfolioSummary.performanceAmount ? formatPrice(newPortfolioSummary.performanceAmount.toLocaleString("fi-FI", {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }).replace(',', '.')) : 0
                                                        }}
                                                    </div>
                                                    <div class="regular">{{
                                                            newPortfolioSummary.performanceRate ? newPortfolioSummary.performanceRate.toLocaleString("fi-FI", {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }).replace(',', '.') : 0
                                                        }}%
                                                    </div>
                                                    <div class="performance down"
                                                         v-if="newPortfolioSummary.performanceRate < 0"></div>
                                                    <div class="performance up"></div>
                                                </div>
                                            </div>
                                            <div class="investments-item total-gain">
                                                <div class="investments-label">{{ $t('bottles-owned') }}</div>
                                                <div class="bold">{{ newPortfolioSummary.bottlesOwnedNow }}</div>
                                            </div>
                                        </v-flex>

                                        <div v-if="wineList.length > 0">
                                            <v-row v-for="portfolioItem in wineArray" :key="portfolioItem.wineId"
                                                   no-gutters>
                                                <div class="portfolio-row">
                                                    <div class="portfolio-row-content">
                                                        <div class="wine-details-head">
                                                            <div class="portfolio-wine-bottle">
                                                                <img :src="portfolioItem.bottlePicture"
                                                                     alt="wine bottle image"
                                                                     class="portfolio-wine-bottle-img">
                                                            </div>
                                                            <div class="right-side new-portfolio-right-side">
                                                                <div v-if="portfolioItem.wineName">
                                                                    <h2 v-on:click="() => goToWineDetails('', portfolioItem)">
                                                                        {{ portfolioItem.vintage }}
                                                                        {{ portfolioItem.wineName }}</h2>
                                                                    <h3 v-if="portfolioItem.isSecondLabel"
                                                                        class="addition-description">2-nd label of
                                                                        {{ portfolioItem.producerTypeName }}
                                                                        {{ portfolioItem.producerName }}</h3>
                                                                    <h3 v-else class="addition-description">
                                                                        {{ portfolioItem.producerTypeName }}
                                                                        {{ portfolioItem.producerName }}</h3>
                                                                </div>
                                                                <div v-else>
                                                                    <h2 v-on:click="() => goToWineDetails('', portfolioItem)">
                                                                        {{ portfolioItem.vintage }}
                                                                        {{ portfolioItem.producerTypeName }}
                                                                        {{ portfolioItem.producerName }}</h2>
                                                                </div>
                                                                <div class="second-row enprimeur-info">
                                                                    <div v-if="portfolioItem.isEnPrimeur"
                                                                         class="wine-enprimeur">
                                                                        En Primeur
                                                                        <div class="info-text">{{
                                                                                $t('will-be-bottled')
                                                                            }}{{ portfolioItem.vintage.charAt(2) }}{{ parseInt(portfolioItem.vintage.charAt(3)) + 3 }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="wine-summary-wrapper">
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('initial-investment') }}
                                                                        </div>
                                                                        <div class="wine-summary-row-value">
                                                                            {{ currencySign }}{{
                                                                                portfolioItem.marketValue.investmentAmount.toLocaleString("fi-FI", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                }).replace(',', '.')
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('market-value') }}
                                                                        </div>
                                                                        <div class="wine-summary-row-value">
                                                                            {{ currencySign }}{{
                                                                                portfolioItem.marketValue.marketValue.toLocaleString("fi-FI", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                }).replace(',', '.')
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('performance') }}
                                                                        </div>
                                                                        <div class="wine-summary-row-value">
                                                                            <div class="wine-summary-row-value1">
                                                                                {{ currencySign }}{{
                                                                                    portfolioItem.marketValue.performanceAmount.toLocaleString("fi-FI", {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    }).replace(',', '.')
                                                                                }}
                                                                            </div>
                                                                            <div class="wine-summary-row-value2"
                                                                                 style="color: rgba(0, 0, 0, 0.64);">{{
                                                                                    portfolioItem.marketValue.performanceRate.toLocaleString("fi-FI", {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    }).replace(',', '.')
                                                                                }}%
                                                                            </div>
                                                                            <div class="wine-summary-row-value3 down"
                                                                                 v-if="portfolioItem.marketValue.performanceRate < 0"></div>
                                                                            <div class="wine-summary-row-value3 up"
                                                                                 v-else></div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('bottles') }}
                                                                        </div>
                                                                        <div class="wine-summary-row-value">
                                                                            {{ portfolioItem.marketValue.numberOfBottles }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row last-child">
                                                                        <div class="perform-btn"
                                                                             v-on:click="() => openWinePerformance('', portfolioItem)">
                                                                            {{ $t('wine-performance') }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wine-portfolio-trades"
                                                             v-for="(item, i) in portfolioItem.casesSizes"
                                                             :key="item.wineId + i">
                                                            <div class="wine-portfolio-trades-row"
                                                                 v-if="portfolioItem.wineId === item.wineId">
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('case-size') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.size }}l
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('myportfolio3') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.owned }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('myportfolio5') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.bidsCases }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('myportfolio6') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.offersCases }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('favourites') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        <button
                                                                            v-on:click="(event) => toggleFav(event, item)"
                                                                            :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box last-child">
                                                                    <div class="btn-secondary market-btn"
                                                                         v-on:click="() => selectWine(item, false)">
                                                                        {{ $t('sell') }}
                                                                    </div>
                                                                    <div class="btn-secondary market-btn ga4-buy-wine"
                                                                         v-on:click="() => selectWine(item, true)">
                                                                        {{ $t('buy') }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-row>
                                        </div>
                                        <div class="no-orders-info" v-if="wineList.length == 0">{{
                                                $t('no-investments')
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </v-tab-item>
                            <v-tab-item value="soldwines">
                                <div class="row">
                                    <div class="col-12">
                                        <FilterComponent
                                            :firstRowOfFilterObjects="this.firstRowOfSoldWinesFilterObjects"
                                            :secondRowOfFilterObjects="this.secondRowOfSoldWinesFilterObjects"
                                            :filtersObj="this.filtersSoldWinesObj"
                                            :onApplyFilters="this.onApplySoldWinesFilters"
                                            :onResetFilters="this.onResetSoldWinesFilters"
                                        />

                                        <v-flex class="my-investments">
                                            <div class="investments-item">
                                                <div class="investments-label">{{ $t('gross-profit') }}</div>
                                                <!--                                                <div class="bold">{{currencySign}}{{ soldWinesSummary.grossProfit }}</div>-->
                                                <div class="bold">{{
                                                        soldWinesSummary.grossProfit ? formatPrice(soldWinesSummary.grossProfit.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.')) : 0
                                                    }}
                                                </div>
                                            </div>
                                            <div class="investments-item">
                                                <div class="investments-label">{{ $t('net-profit') }}</div>
                                                <!--                                                <div class="bold">{{currencySign}}{{ soldWinesSummary.netProfit }}</div>-->
                                                <div class="bold">{{
                                                        soldWinesSummary.netProfit ? formatPrice(soldWinesSummary.netProfit.toLocaleString("fi-FI", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }).replace(',', '.')) : 0
                                                    }}
                                                </div>
                                            </div>
                                            <div class="investments-item investment-item-performance">
                                                <div class="investments-label">{{ $t('roi') }}</div>
                                                <div class="rate-wrapper">
                                                    <!--                                                    <div class="bold">{{soldWinesSummary.roiPercentageGross}}%</div>-->
                                                    <div class="bold">{{
                                                            soldWinesSummary.roiPercentageGross ? soldWinesSummary.roiPercentageGross.toLocaleString("fi-FI", {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }).replace(',', '.') : 0
                                                        }}%
                                                    </div>
                                                    <div class="performance down"
                                                         v-if="soldWinesSummary.roiPercentageGross < 0"></div>
                                                    <div class="performance up"></div>
                                                </div>
                                            </div>
                                            <div class="investments-item total-gain">
                                                <div class="investments-label">{{ $t('bottles-sold') }}</div>
                                                <div class="bold">{{ soldWinesSummary.bottleSold }}</div>
                                            </div>
                                        </v-flex>

                                        <div v-if="soldWinesList.length > 0">
                                            <v-row v-for="soldWineItem in soldWinesList" :key="soldWineItem.wineVintageId" no-gutters>
                                                <div class="portfolio-row">
                                                    <div class="portfolio-row-content">
                                                        <div class="wine-details-head">
                                                            <div class="portfolio-wine-bottle">
                                                                <img :src="soldWineItem.bottlePicture"
                                                                     alt="wine bottle image"
                                                                     class="portfolio-wine-bottle-img">
                                                            </div>
                                                            <div class="right-side new-portfolio-right-side">
                                                                <div v-if="soldWineItem.wineDisplayName">
                                                                    <h2 v-on:click="() => goToWineDetails('sold-wines', soldWineItem)">
                                                                        {{ soldWineItem.wineDisplayName }}</h2>
                                                                    <h3 v-if="soldWineItem.isSecondLabel"
                                                                        class="addition-description">2-nd label of
                                                                        {{ soldWineItem.producerType }}
                                                                        {{ soldWineItem.producer }}</h3>
                                                                    <h3 v-else class="addition-description">{{ soldWineItem.producerType }} {{ soldWineItem.producer }}</h3>
                                                                </div>
                                                                <div v-else>
                                                                    <h2 v-on:click="() => goToWineDetails('sold-wines', soldWineItem)">
                                                                        {{ soldWineItem.vintage }}
                                                                        {{ soldWineItem.producerType }}
                                                                        {{ soldWineItem.producer }}</h2>
                                                                </div>
                                                                <div class="second-row enprimeur-info">
                                                                    <div v-if="soldWineItem.isEnPrimeur"
                                                                         class="wine-enprimeur">
                                                                        En Primeur
                                                                        <div class="info-text">{{
                                                                                $t('will-be-bottled')
                                                                            }}{{ soldWineItem.vintage.charAt(2) }}{{ parseInt(soldWineItem.vintage.charAt(3)) + 3 }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="wine-summary-wrapper"
                                                                     v-if="soldWineItem.summaryWines">
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('gross-profit') }}
                                                                        </div>
                                                                        <!--                                                                        <div class="wine-summary-row-value">{{currencySign}} {{soldWineItem.summaryWines.grossProfit.toFixed(2)}}</div>-->
                                                                        <div class="wine-summary-row-value">{{
                                                                                formatPrice(soldWineItem.summaryWines.grossProfit.toLocaleString("fi-FI", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                }).replace(',', '.'))
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('net-profit') }}
                                                                        </div>
                                                                        <!--                                                                        <div class="wine-summary-row-value">{{currencySign}} {{soldWineItem.summaryWines.netProfit.toFixed(2)}}</div>-->
                                                                        <div class="wine-summary-row-value">{{
                                                                                formatPrice(soldWineItem.summaryWines.netProfit.toLocaleString("fi-FI", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                }).replace(',', '.'))
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">{{
                                                                                $t('roi')
                                                                            }}
                                                                        </div>
                                                                        <div class="wine-summary-row-value">
                                                                            <div class="wine-summary-row-value1">{{
                                                                                    soldWineItem.summaryWines.roiPercentageGross.toLocaleString("fi-FI", {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    }).replace(',', '.')
                                                                                }}%
                                                                            </div>
                                                                            <div class="wine-summary-row-value3 down"
                                                                                 v-if="soldWineItem.summaryWines.roiPercentageGross < 0"></div>
                                                                            <div class="wine-summary-row-value3 up"
                                                                                 v-else></div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="wine-summary-row-title">
                                                                            {{ $t('bottles-sold') }}
                                                                        </div>
                                                                        <div class="wine-summary-row-value">
                                                                            {{ soldWineItem.summaryWines.bottleSold }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="wine-summary-row">
                                                                        <div class="perform-btn"
                                                                             v-on:click="() => openWinePerformance('sold-wines', soldWineItem)">
                                                                            {{ $t('wine-performance') }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wine-portfolio-trades">
                                                            <div class="wine-portfolio-trades-row"
                                                                 v-for="sellTransaction in soldWineItem.sellTransactions">
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('case-size') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ sellTransaction.caseSize }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('sell-date') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ formatDate(sellTransaction.sellDate) }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('cases-sold') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ sellTransaction.casesSold }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('sell-price') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice(sellTransaction.sellPrice.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('total-sell-amount') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice(sellTransaction.totalSellAmount.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('revenue') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice(sellTransaction.revenue.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('gross-profit') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice(sellTransaction.grossProfit.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('sell-order-no') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value link"
                                                                         v-on:click="() => $emit('triggerSalesInvoiceDetailsPage', sellTransaction.saleOrderId)">
                                                                        no. {{ sellTransaction.saleOrderId }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-row>
                                        </div>
                                        <div class="no-orders-info" v-if="soldWinesList.length == 0">
                                            {{ $t('no-sold-wines') }}
                                        </div>
                                    </div>
                                </div>
                            </v-tab-item>
                            <v-tab-item value="bidsoffers">
                                <div class="row">
                                    <div class="col-12">
                                        <FilterComponent
                                            :firstRowOfFilterObjects="this.firstRowOfBidsAndOffersFilterObjects"
                                            :secondRowOfFilterObjects="this.secondRowOfBidsAndOffersFilterObjects"
                                            :filtersObj="this.filtersBidsAndOffersObj"
                                            :onApplyFilters="this.onApplyBidsAndOffersFilters"
                                            :onResetFilters="this.onResetBidsAndOffersFilters"
                                        />
                                        <div v-if="ordersLength > 0">
                                            <v-row v-for="(orderItem, index) in groupedOrders"
                                                   :key="orderItem.wineId + index" no-gutters>
                                                <div class="portfolio-row">
                                                    <div class="portfolio-row-header">
                                                        <div class="last-trade">
                                                            {{ formatDate(orderItem.createdOn) }}
                                                        </div>
                                                    </div>
                                                    <div class="portfolio-row-content">
                                                        <div class="wine-details-head wine-details-head-bids">
                                                            <div class="left-side">
                                                                <div class="image">
                                                                    <img :src="orderItem.bottlePicture"
                                                                         alt="wine bottle picture">
                                                                </div>
                                                            </div>
                                                            <div class="right-side">
                                                                <div v-if="orderItem.wineName">
                                                                    <h2 v-on:click="() => goToWineDetails2(orderItem)">
                                                                        {{ orderItem.vintage }}
                                                                        {{ orderItem.wineName }}</h2>
                                                                    <h3 v-if="orderItem.isSecondLabel"
                                                                        class="addition-description">2-nd label of
                                                                        {{ orderItem.producerTypeName }}
                                                                        {{ orderItem.producerName }}</h3>
                                                                    <h3 v-else class="addition-description">{{ orderItem.producerTypeName }} {{ orderItem.producerName }}</h3>
                                                                </div>
                                                                <div v-else>
                                                                    <h2 v-on:click="() => goToWineDetails2(orderItem)">
                                                                        {{ orderItem.vintage }}
                                                                        {{ orderItem.producerTypeName }}
                                                                        {{ orderItem.producerName }}</h2>
                                                                </div>
                                                                <div class="second-row second-row-bids">
                                                                    <div v-if="orderItem.isEnPrimeur"
                                                                         class="wine-enprimeur wine-enprimeur-bids">
                                                                        En Primeur
                                                                        <div class="info-text">{{
                                                                                $t('will-be-bottled')
                                                                            }}{{ orderItem.vintage.charAt(2) }}{{ parseInt(orderItem.vintage.charAt(3)) + 3 }}
                                                                        </div>
                                                                    </div>

                                                                    <div class="status">
                                                                        <span class="chip bid"
                                                                              v-if="orderItem.orderType === 'BID'">{{
                                                                                $t('bid')
                                                                            }}</span>
                                                                        <span class="chip offer"
                                                                              v-else>{{ $t('bo-offer') }}</span>
                                                                        <span class="chip cancelled"
                                                                              v-if="orderItem.status === 5"><span></span>{{
                                                                                $t('trade-history9')
                                                                            }}</span>
                                                                        <span class="chip expired"
                                                                              v-else-if="orderItem.status === 11"><span></span>{{
                                                                                $t('bo-expired')
                                                                            }}</span>
                                                                        <span class="chip active"
                                                                              v-else-if="orderItem.status === 1"><span></span>{{
                                                                                $t('bo-active')
                                                                            }}</span>
                                                                        <span class="chip expired" v-else><span></span>-</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wine-portfolio-offers-wrapper"
                                                             v-if="orderItem.orderType === 'OFFER'">
                                                            <div class="wine-portfolio-trades-row"
                                                                 v-for="item in orderItem.orders" :key="item.id">
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('case-size') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.size }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('cases') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.units }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('price-per-case') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            item.price ? formatPrice(item.price.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.')) : '-'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('buy13') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice((item.commission + item.commissionVat).toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('return') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice(item.return.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('profit') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            item.profit ? formatPrice(item.profit.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.')) : '-'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div v-if="item.status === 5 || item.status === 11"
                                                                         class="perform-btn"
                                                                         v-on:click="() => selectWine(item, false)">
                                                                        {{ $t('activate-offer') }}
                                                                    </div>
                                                                    <div v-else class="perform-btn"
                                                                         v-on:click="() => { showDeleteModal(item.id, 'offer') }">
                                                                        {{ $t('cancel-offer') }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wine-portfolio-bids-wrapper" v-else>
                                                            <div class="wine-portfolio-trades-row"
                                                                 v-for="item in orderItem.orders" :key="item.id">
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('case-size') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.size }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('cases') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">
                                                                        {{ item.units }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('expires-in') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            item.expireAfterDays ? `${item.expireAfterDays} days` : '-'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('price-per-case') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            item.price ? formatPrice(item.price.toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.')) : '-'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('buy13') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice((item.commission + item.commissionVat).toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('storage') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            item.storage ? formatPrice((item.storage + item.storageVat).toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.')) : '-'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('insurance') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            item.insurance ? formatPrice((item.insurance + item.insuranceVat).toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.')) : '-'
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div class="wine-portfolio-trades-box-title">
                                                                        {{ $t('total-cost') }}
                                                                    </div>
                                                                    <div class="wine-portfolio-trades-box-value">{{
                                                                            formatPrice((item.totalPrice + item.commission + item.commissionVat + item.storage + item.storageVat).toLocaleString("fi-FI", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }).replace(',', '.'))
                                                                        }}
                                                                    </div>
                                                                </div>
                                                                <div class="wine-portfolio-trades-box">
                                                                    <div v-if="item.status === 5 || item.status === 11"
                                                                         class="perform-btn"
                                                                         v-on:click="() => selectWine(item, true)">
                                                                        {{ $t('activate-bid') }}
                                                                    </div>
                                                                    <div v-else class="perform-btn"
                                                                         v-on:click="() => { showDeleteModal(item.id, item.orderType) }">
                                                                        {{ $t('cancel-bid') }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-row>
                                        </div>
                                        <div class="no-orders-info" v-if="ordersLength === 0">{{
                                                $t('myportfolio10')
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <transition name="fade">
                        <div class="scrollToTopButton" v-show="scrollTopYPos > 300" @click="toTop">
                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect y="0.603516" width="40" height="40" rx="8" fill="#004F7F"/>
                                <path
                                    d="M25.5915 22.1932C25.9811 22.5828 25.9811 23.2144 25.5915 23.604C25.2022 23.9933 24.5712 23.9936 24.1815 23.6047L20.2969 19.7286L16.4123 23.6047C16.0226 23.9936 15.3915 23.9933 15.0023 23.604C14.6127 23.2144 14.6127 22.5828 15.0023 22.1932L19.5898 17.6057C19.9803 17.2152 20.6135 17.2152 21.004 17.6057L25.5915 22.1932Z"
                                    fill="white"/>
                            </svg>
                        </div>
                    </transition>
                </div>
            </div>

            <v-dialog v-model="giftModal" max-width="496px">
                <v-card class="gift-modal">
                    <div class="close-modal" v-on:click="resetGiftModal(true)">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M11.6897 0.344433C12.1007 0.738147 12.1007 1.39508 11.6897 1.7888L7.29269 6.00022L11.6897 10.2116C12.1007 10.6053 12.1007 11.2623 11.6897 11.656L11.6201 11.7226C11.2337 12.0927 10.6243 12.0931 10.2375 11.7234L5.99898 7.67256L1.76047 11.7234C1.37362 12.0931 0.764287 12.0927 0.377845 11.7226L0.308296 11.656C-0.102765 11.2623 -0.102766 10.6053 0.308296 10.2116L4.70528 6.0002L0.308318 1.7888C-0.102744 1.39508 -0.102743 0.738147 0.308318 0.344433L0.377867 0.277819C0.764309 -0.0923146 1.37364 -0.0926466 1.76049 0.277066L5.999 4.32786L10.2375 0.277066C10.6244 -0.0926465 11.2337 -0.0923141 11.6201 0.277819L11.6897 0.344433Z"
                                  fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>
                    <v-card-text class="cancel-bid-body" v-if="!activationSuccessful && !activationError">
                        <h3>{{ $t('apply-gift') }}</h3>
                        <p>Your unique code can be found on your gift box certificate. Please enter the code into the
                            box below to activate retrieval of your Wine Collection!</p>
                        <v-text-field class="gift-code" label="Enter code" placeholder="Enter your gift code here"
                                      v-model="giftCode"></v-text-field>
                    </v-card-text>
                    <v-card-text class="cancel-bid-body" v-if="activationSuccessful && !activationError">
                        <h3>Congratulations!</h3>
                        <p style="text-align: center">You added a gift to your portfolio.</p>
                    </v-card-text>
                    <v-card-text class="cancel-bid-body" v-if="!activationSuccessful && activationError">
                        <h3>Activation failed!</h3>
                        <p style="text-align: center">Please enter a valid gift code.</p>
                    </v-card-text>

                    <v-card-actions v-if="!activationSuccessful && !activationError">
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="activateGift"
                               :disabled="giftCode == ''">Activate
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="activationSuccessful && !activationError">
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="resetGiftModal(true)">View
                            portfolio
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="!activationSuccessful && activationError">
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="resetGiftModal(false)">Try again
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <AddAddressModal :status="addNewAddressDialog" :addAdressButtonLoader="addAdressButtonLoader"
                             :newAddress="newAddress" :country="country" :country-error="countryError"/>

            <v-dialog v-model="virtualCellarModal" max-width="496px">
                <v-card class="virtual-cellar-modal">
                    <h3>{{ $t('virtual-wine-cellar-coming-soon') }}</h3>

                    <v-card-actions>
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="closeVirtualCellarModalHandler">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="cancelBidModal" max-width="496px">
                <v-card class="bids-offers-modal">
                    <div class="warning-icon"></div>
                    <v-card-title>Are you sure you want to cancel your {{ cancelBidType }}?</v-card-title>

                    <v-card-actions>
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="cancelOrder">Cancel
                            {{ cancelBidTypeFormatted }}
                        </v-btn>
                        <v-btn class="btn-secondary btn-bid-cancel" text v-on:click="cancelBidModal = false">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from 'vuex';
import {GPortfolio, GOrders, GWines, GPerformance, GUser, GCommon, GMarket} from '@/store/getters';
import {APortfolio, AOrders, AWines, AUser, APerformance} from '@/store/actions';
import moment from 'moment';
import Transactions from "./PortfolioPerformance/Transactions";
import WineCellar from "./PortfolioPerformance/WineCellar";
import YourWines from "./PortfolioPerformance/YourWines";
import InvestmentCharts from "./PortfolioPerformance/InvestmentCharts";
import FilterComponent from "./FilterComponent"
import AddAddressModal from "@/components/Modals/AddAddressModal.vue";

export default {
    name: "Portfolio",
    props: {
        preselectedTab: String
    },
    components: {
        YourWines,
        Transactions,
        WineCellar,
        InvestmentCharts,
        FilterComponent,
        AddAddressModal
    },
    data() {
        return {
            isLogged: false,
            groupedOrders: {},
            ordersLength: 0,
            cancelBidModal: false,
            cancelBidType: '',
            giftModal: false,
            virtualCellarModal: false,
            cancelBidId: null,
            selectedRegionTab: 0,
            giftCode: '',
            activationSuccessful: false,
            activationError: false,
            passedWineIds: [],
            showGift: false,
            filtersInvestmentsObj: {
                vintageId: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                producerId: null,
                colorId: null,
                isEnPrimeur: null
            },
            filtersBidsAndOffersObj: {
                vintageId: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                producerId: null,
                ColourId: null,
                PendingOrderType: null,
                PendingOrderStatus: null,
                isEnPrimeur: null
            },
            filtersSoldWinesObj: {
                vintage: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                producerId: null,
                colorId: null,
                type: null,
                status: null,
            },
            cachedWines: [],
            firstRowOfInvestmentsFilterObjects: [],
            secondRowOfInvestmentsFilterObjects: [],
            firstRowOfBidsAndOffersFilterObjects: [],
            secondRowOfBidsAndOffersFilterObjects: [],
            firstRowOfSoldWinesFilterObjects: [],
            secondRowOfSoldWinesFilterObjects: [],
            scrollTopTimer: 0,
            scrollTopYPos: 0,
            addNewAddressDialog: false,
            addAdressButtonLoader: false,
            newAddress: {
                name: "",
                type: 3,
                street: "",
                street1: "",
                city: "",
                postCode: "",
                countryId: 4,
                country: "",
                vat: "",
                note: "",
                company: "",
                phoneNumber: "",
                firstName: "",
                lastName: ""
            },
            country: null,
            countryError: false,
            userBrowser: '',
            userDevice: ''
        }
    },
    computed: {
        ...mapState({
            countries: state => state.countries
        }),
        ...mapGetters({
            userData: GUser.GET_USER_DATA,
            wineList: GPortfolio.GET_PORTFOLIO_WINE_LIST,
            wineListLoading: GPortfolio.GET_PORTFOLIO_WINE_LIST_LOADING,
            portfolioValue: GPortfolio.GET_PORTFOLIO_VALUE,
            portfolioProfit: GPortfolio.GET_PORTFOLIO_TOTAL_PROFIT,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            newPortfolioSummary: GPortfolio.GET_NEW_PORTFOLIO_SUMMARY,
            soldWinesList: GPortfolio.GET_SOLD_WINES_LIST,
            soldWinesSummary: GPortfolio.GET_SOLD_WINES_SUMMARY,
            favWinesList: GWines.GET_FAVOURITE_WINES,
            orders: GOrders.GET_BIDS_AND_OFFERS,
            tradesList: GOrders.GET_TRADES_HISTORY,
            currencySign: GCommon.GET_CURRENCY_SIGN,
            regionList: GPerformance.GET_REGION_LIST,
            colourList: GPerformance.GET_COLOUR_LIST,
            regionsList: GCommon.GET_REGIONS_LIST,
            appellationsList: GCommon.GET_APPELLATIONS_LIST,
            producersList: GMarket.GET_PRODUCERS,
            investmentsFilters: GPerformance.GET_INVESTMENTS_FILTERS,
            bidsOffersFilters: GPerformance.GET_BIDSOFFERS_FILTERS,
            soldWinesFilters: GPerformance.GET_SOLDWINES_FILTERS,
            addressList: GUser.GET_ADDRESSES,
        }),
        portfolioSelectedTab: {
            set(portfolioSelectedTab) {
                this.$router.push(this.localePath({path: '/my-account/?portfolioSelectedTab=' + portfolioSelectedTab}));
                this.showGift = (portfolioSelectedTab === 'investments' || portfolioSelectedTab === 'performance')
            },
            get() {
                this.showGift = (this.$route.query.portfolioSelectedTab === 'investments' || this.$route.query.portfolioSelectedTab === 'performance')

                return this.$route.query.portfolioSelectedTab
            }
        },
        cancelBidTypeFormatted() {
            function capitalize(string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            }

            return capitalize(this.cancelBidType)
        },
        getInvesmentsTransactionsLength() {
            return this.tradesList.length
        },
        getInvestmentsTransactions() {
            let updatedListItems = [];

            this.tradesList.forEach(item => {
                if (item.status === 2 || item.status === 4) {
                    let invoiceItem = {};
                    invoiceItem.id = item.id;
                    invoiceItem.documentTypeId = item.documentTypeId;
                    invoiceItem.documentId = item.documentId === 0 ? '-' : item.documentId;
                    invoiceItem.date = moment(item.date).locale(this.$i18n.locale).format('DD MMM YYYY');
                    invoiceItem.order = item.isBuy ? 'Buy' : 'Sell';
                    invoiceItem.invoiceType = item.type;
                    invoiceItem.type = item.type === 1 ? 'Bid' : (item.type === 2 ? 'Buy' : (item.type === 3 ? 'Offer' : 'Sale'));
                    invoiceItem.quantity = item.quantity;
                    invoiceItem.wine = item.wine;
                    invoiceItem.bottlePicture = item.bottlePicture;
                    invoiceItem.service = this.formatPrice(item.servicesInclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    invoiceItem.total = this.formatPrice(item.totalInclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    updatedListItems.push(invoiceItem);
                }
            });

            return updatedListItems.slice(0, 3);
        },
        vintageMap() {
            let allVintages = [];
            let allVintagesIndexes = [];
            this.cachedWines.forEach(item => {
                if (allVintagesIndexes.indexOf(item.vintage) === -1) {
                    let newVintage = {};
                    newVintage.id = item.vintage;
                    newVintage.value = item.vintage;
                    allVintages.push(newVintage);
                    allVintagesIndexes.push(item.vintage)
                }
            });
            allVintages.sort(function (a, b) {
                return a.value - b.value;
            });
            return allVintages
        },
        filteredItems() {
            return this.portfolioSummary.map(item => {
                let isWineInFavourites = false;

                this.favWinesList.forEach(wine => {
                    if (item.wineId === wine.wineId && item.caseSizeId === wine.caseSizeId) {
                        isWineInFavourites = true;
                    }
                });
                return Object.assign({isFavourite: isWineInFavourites}, item);
            })
        },
        wineArray() {
            let sortedWines = [];
            let sortedWinesIds = [];
            let arrayIndex = 0;


            this.portfolioSummary.map(el => {
                let currWineIndex = sortedWinesIds.indexOf(el.portfolioSummary[0].wineId);
                if (currWineIndex === -1) {
                    sortedWinesIds.push(el.portfolioSummary[0].wineId);
                    sortedWines[arrayIndex] = {};

                    sortedWines[arrayIndex].wineId = el.portfolioSummary[0].wineId;
                    sortedWines[arrayIndex].wineVintageId = el.wineVintageId;
                    sortedWines[arrayIndex].wine = el.portfolioSummary[0].wine;
                    sortedWines[arrayIndex].wineName = el.portfolioSummary[0].wineName;
                    sortedWines[arrayIndex].isEnPrimeur = el.portfolioSummary[0].isEnPrimeur || false;
                    sortedWines[arrayIndex].isSecondLabel = el.portfolioSummary[0].isSecondLabel;
                    sortedWines[arrayIndex].appellationId = el.portfolioSummary[0].appellationId;
                    sortedWines[arrayIndex].appellation = el.portfolioSummary[0].appellation;
                    sortedWines[arrayIndex].regionId = el.portfolioSummary[0].regionId;
                    sortedWines[arrayIndex].regionName = el.portfolioSummary[0].regionName;
                    sortedWines[arrayIndex].countryId = el.portfolioSummary[0].countryId;
                    sortedWines[arrayIndex].countryName = el.portfolioSummary[0].countryName;
                    sortedWines[arrayIndex].colorId = el.portfolioSummary[0].colorId;
                    sortedWines[arrayIndex].color = el.portfolioSummary[0].color;
                    sortedWines[arrayIndex].classification = el.portfolioSummary[0].classification;
                    sortedWines[arrayIndex].lastTraded = el.portfolioSummary[0].lastTraded;
                    sortedWines[arrayIndex].vintage = el.portfolioSummary[0].vintage;
                    sortedWines[arrayIndex].producerName = el.portfolioSummary[0].producerName;
                    sortedWines[arrayIndex].producerTypeName = el.portfolioSummary[0].producerTypeName;
                    sortedWines[arrayIndex].casesSizes = [];
                    sortedWines[arrayIndex].marketValue = {
                        calculationDate: el.marketValue !== 0 ? el.marketValue.calculationDate : 0,
                        investmentAmount: el.marketValue !== 0 ? el.marketValue.investmentAmount : 0,
                        marketValue: el.marketValue !== 0 ? el.marketValue.marketValue : 0,
                        numberOfBottles: el.marketValue !== 0 ? el.marketValue.numberOfBottles : 0,
                        performanceAmount: el.marketValue !== 0 ? el.marketValue.performanceAmount : 0,
                        performanceRate: el.marketValue !== 0 ? el.marketValue.performanceRate : 0,
                        wineVintageId: el.marketValue !== 0 ? el.marketValue.wineVintageId : 0,
                    };

                    for (let j = 0; j < this.wineList.length; j++) {
                        if (el.portfolioSummary[0].wineId === this.wineList[j].wine.wineId) {
                            sortedWines[arrayIndex].bottlePicture = this.wineList[j].wine.picture.bottlePicture;
                            break;
                        }
                    }

                    el.portfolioSummary.map(caseSize => {
                        let newWineCase = {};

                        newWineCase.isFavourite = false;
                        newWineCase.size = caseSize.size;
                        newWineCase.caseSizeId = caseSize.caseSizeId;
                        newWineCase.wineId = caseSize.wineId;
                        newWineCase.offersCases = caseSize.offersCases;
                        newWineCase.bidsCases = caseSize.bidsCases;
                        newWineCase.gain = caseSize.gain;
                        newWineCase.averageBuyPrice = caseSize.averageBuyPrice;
                        newWineCase.owned = caseSize.owned;

                        sortedWines[arrayIndex].casesSizes.push(newWineCase);
                    })

                    arrayIndex++;
                } else {
                    el.portfolioSummary.map(caseSize => {
                        let newWineCase = {};

                        newWineCase.isFavourite = false;
                        newWineCase.size = caseSize.size;
                        newWineCase.caseSizeId = caseSize.caseSizeId;
                        newWineCase.wineId = caseSize.wineId;
                        newWineCase.offersCases = caseSize.offersCases;
                        newWineCase.bidsCases = caseSize.bidsCases;
                        newWineCase.gain = caseSize.gain;
                        newWineCase.averageBuyPrice = caseSize.averageBuyPrice;
                        newWineCase.owned = caseSize.owned;

                        sortedWines[currWineIndex].casesSizes.push(newWineCase)
                    })
                }
            })

            for (let key in sortedWines) {
                for (let k = 0; k < sortedWines[key].casesSizes.length; k++) {
                    this.favWinesList.forEach(wine => {
                        if (sortedWines[key].casesSizes[k].wineId === wine.wineId && sortedWines[key].casesSizes[k].caseSizeId === wine.caseSizeId) {
                            sortedWines[key].casesSizes[k].isFavourite = true;
                        }
                    });
                }
            }
            return sortedWines;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.userBrowser = this.fnBrowserDetect();
        this.userDevice = this.detectDeviceType();

        this.$nuxt.$on('langUpdated', () => {
            this.updateFiltersData()
        })
    },
    methods: {
        ...mapActions({
            loadWines: APortfolio.LOAD_WINES,
            loadWinesSummary: APortfolio.GET_PORTFOLIO_SUMMARY,
            loadNewSummary: APortfolio.GET_NEW_PORTFOLIO_SUMMARY,
            loadSoldWinesSummary: APortfolio.GET_SOLD_WINES_SUMMARY,
            loadSoldWinesList: APortfolio.GET_SOLD_WINES_LIST,
            loadFavWines: AWines.GET_FAVOURITE_WINES,
            getOrders: AOrders.GET_ORDERS,
            setInitialTrades: AOrders.GET_INITIAL_TRADES,
            getTrades: AOrders.GET_TRADES,
            cancelOrderAsync: AOrders.CANCEL_ORDER,
            loadRegion: APerformance.LOAD_REGION_LIST,
            loadColour: APerformance.LOAD_COLOUR_LIST,
            loadInvestmentsFilters: APerformance.LOAD_INVESTMENTS_FILTERS,
            loadBidsOffersFilters: APerformance.LOAD_BIDSOFFERS_FILTERS,
            loadSoldWinesFilters: APerformance.LOAD_SOLDWINES_FILTERS,

            // loadMarketValues: APerformance.LOAD_MARKET_VALUES,
            // loadMarketWinesValues: APerformance.LOAD_MARKET_WINES_VALUES
        }),
        onVintageInvestmentsFieldClickHandler() {
            let selectedVintageId = this.filtersInvestmentsObj.vintageId;

            this.investmentsFilters.vintages.find(el => {
                if (el.id === selectedVintageId) {
                    this.filtersInvestmentsObj.isEnPrimeur = el.isEnPrimeur
                }
            })
        },
        onVintageBidsOffersFieldClickHandler() {
            let selectedVintageId = this.filtersBidsAndOffersObj.vintageId;

            this.bidsOffersFilters.vintages.find(el => {
                if (el.id === selectedVintageId) {
                    this.filtersBidsAndOffersObj.isEnPrimeur = el.isEnPrimeur
                }
            })
        },
        onProducerInvestmentsFieldClickHandler() {
            let selectedProducerId = this.filtersInvestmentsObj.producerId;

            this.investmentsFilters.producers.find(el => {
                if (el.id === selectedProducerId) {
                    if (el.isWine) {
                        this.filtersInvestmentsObj.wineId = null
                        this.filtersInvestmentsObj.ghostWineId = el.id
                        this.filtersInvestmentsObj.producerId = null
                        this.filtersInvestmentsObj.ghostProducerId = null
                    } else {
                        this.filtersInvestmentsObj.wineId = null
                        this.filtersInvestmentsObj.ghostWineId = null
                        this.filtersInvestmentsObj.producerId = el.id
                        this.filtersInvestmentsObj.ghostProducerId = el.id
                    }
                }
            })
        },
        onApplyInvestmentsFilters() {
            let findActiveSorting = this.secondRowOfInvestmentsFilterObjects.find(el => el.isActive)
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY, {
                sorting: findActiveSorting ? findActiveSorting.className : '',
                filtersObj: this.filtersInvestmentsObj
            });
            this.$store.dispatch(APortfolio.GET_NEW_PORTFOLIO_SUMMARY, {filtersObj: this.filtersInvestmentsObj});
        },
        onResetInvestmentsFilters() {
            const elWithActiveClass = this.secondRowOfInvestmentsFilterObjects.find(el => el.isActive === true)

            this.filtersInvestmentsObj = {
                vintageId: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                ghostWineId: null,
                producerId: null,
                ghostProducerId: null,
                colorId: null,
                isEnPrimeur: null
            }
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY, {
                sorting: '',
                filtersObj: this.filtersInvestmentsObj
            });
            this.$store.dispatch(APortfolio.GET_NEW_PORTFOLIO_SUMMARY, {filtersObj: this.filtersInvestmentsObj});
            elWithActiveClass.isActive = false
        },
        onProducerBidsAndOffersFieldClickHandler() {
            let selectedProducerId = this.filtersBidsAndOffersObj.producerId;

            this.bidsOffersFilters.producers.find(el => {
                if (el.id === selectedProducerId) {
                    if (el.isWine) {
                        // this.filtersBidsAndOffersObj.producerId = null
                        this.filtersBidsAndOffersObj.wineId = null
                        this.filtersBidsAndOffersObj.ghostWineId = el.id
                    } else {
                        this.filtersBidsAndOffersObj.wineId = null
                        this.filtersBidsAndOffersObj.producerId = el.id
                        this.filtersBidsAndOffersObj.ghostProducerId = el.id
                    }
                }
            })
        },
        onApplyBidsAndOffersFilters() {
            this.$store.dispatch(AOrders.GET_ORDERS, this.filtersBidsAndOffersObj)
        },
        onResetBidsAndOffersFilters() {
            this.filtersBidsAndOffersObj = {
                vintageId: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                ghostWineId: null,
                producerId: null,
                ghostProducerId: null,
                ColourId: null,
                PendingOrderType: null,
                PendingOrderStatus: null,
                isEnPrimeur: null
            }
            this.$store.dispatch(AOrders.GET_ORDERS, this.filtersBidsAndOffersObj)
        },
        onProducerSoldWinesFieldClickHandler() {
            let selectedProducerId = this.filtersSoldWinesObj.producerId;

            this.soldWinesFilters.producers.find(el => {
                if (el.id === selectedProducerId) {
                    if (el.isWine) {
                        this.filtersSoldWinesObj.wineId = null
                        this.filtersSoldWinesObj.ghostWineId = el.id
                    } else {
                        this.filtersSoldWinesObj.wineId = null
                        this.filtersSoldWinesObj.producerId = el.id
                        this.filtersSoldWinesObj.ghostProducerId = el.id
                    }
                }
            })
        },
        onApplySoldWinesFilters() {
            this.$store.dispatch(APortfolio.GET_SOLD_WINES_LIST, {filtersObj: this.filtersSoldWinesObj});
            this.$store.dispatch(APortfolio.GET_SOLD_WINES_SUMMARY, {filtersObj: this.filtersSoldWinesObj});
        },
        onResetSoldWinesFilters() {
            const elWithActiveClass = this.secondRowOfSoldWinesFilterObjects.find(el => el.isActive === true)

            this.filtersSoldWinesObj = {
                vintage: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                ghostWineId: null,
                producerId: null,
                ghostProducerId: null,
                colorId: null,
                type: null,
                status: null,
            }

            this.$store.dispatch(APortfolio.GET_SOLD_WINES_LIST, {sorting: '', filtersObj: this.filtersSoldWinesObj});
            this.$store.dispatch(APortfolio.GET_SOLD_WINES_SUMMARY, {filtersObj: this.filtersSoldWinesObj});
            elWithActiveClass.isActive = false
        },
        onInvestmentsSortButtonClickHandler(pos) {
            const activeEl = this.secondRowOfInvestmentsFilterObjects.find(el => el.className === pos)
            const inActiveEl = this.secondRowOfInvestmentsFilterObjects.find(el => el.className !== pos)

            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY, {
                sorting: pos,
                filtersObj: this.filtersInvestmentsObj
            });

            activeEl.isActive = true
            inActiveEl.isActive = false
        },
        onSoldWinesSortButtonClickHandler(pos) {
            const activeEl = this.secondRowOfSoldWinesFilterObjects.find(el => el.className === pos)
            const inActiveEl = this.secondRowOfSoldWinesFilterObjects.find(el => el.className !== pos)

            this.$store.dispatch(APortfolio.GET_SOLD_WINES_LIST, {sorting: pos, filtersObj: this.filtersSoldWinesObj});

            activeEl.isActive = true
            inActiveEl.isActive = false
        },
        returnStatus(id) {
            return (id === 11 ? 'Expired' : (id === 5 ? 'Canceled' : 'Active'))
        },
        formatPrice(price) {
            return `€ ${price}`
        },
        transactionsCTAHandler() {
            this.$router.push('/my-account/bank-details')
        },
        activateGift() {
            if (this.giftCode) {
                if (this.addressList.length !== 0) {
                    this.$store.dispatch(AOrders.ACTIVATE_GIFT, this.giftCode).then((res) => {
                        if (res.succeeded) {
                            this.activationSuccessful = true;
                            this.activationError = false;
                            this.loadWines();
                            this.loadWinesSummary();
                            this.loadFavWines();
                            this.getOrders();
                        } else {
                            this.giftModal = true
                            this.activationSuccessful = false;
                            this.activationError = true;
                        }
                    }).catch(() => {
                        this.activationSuccessful = false;
                        this.activationError = true;
                    })
                } else {
                    this.giftModal = false
                    this.addNewAddressDialog = true
                }
            }
        },
        resetGiftModal(closeModal) {
            this.activationSuccessful = false;
            this.activationError = false;
            this.giftCode = '';

            if (closeModal) {
                this.giftModal = false
            }
        },
        formatDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY')
        },
        selectWine(item, isBuy) {
            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale,
                price: item.price,
                units: item.units
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS);
            this.$router.push(this.localePath({path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId}));
        },
        openWinePerformance(location = "", item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: (item.wineVintageId ? item.wineVintageId : item.wineId),
                caseSize: (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId),
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: '/wine-performance/' + (item.wineVintageId ? item.wineVintageId : item.wineId) + '/' + (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId) + '/' + (typeof item.appellation !== 'undefined' && item.appellation ? item.appellation.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.classification !== 'undefined' && item.classification) ? item.classification.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.color !== 'undefined' && item.color) ? item.color.toLowerCase() : "") + '-' + ((typeof item.producerName !== 'undefined' && item.producerName) ? item.producerName.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.producerTypeName !== 'undefined' && item.producerTypeName) ? item.producerTypeName.toLowerCase().split(' ').join('-') : "")}));
                window.scrollTo(0, 0)
            })
        },
        showDeleteModal(id, type) {
            this.cancelBidId = id;
            this.cancelBidModal = true;
            this.cancelBidType = type;
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        goToRegister() {
            this.$router.push(this.localePath({path: '/register'}));
        },
        closeVirtualCellarModalHandler() {
            this.virtualCellarModal = false;
        },
        fnBrowserDetect(){
            let userAgent = navigator.userAgent;
            let browserName;

            if (userAgent.match(/chrome|chromium|crios/i)){
                browserName = "Chrome";
            } else if(userAgent.match(/firefox|fxios/i)){
                browserName = "Firefox";
            }  else if(userAgent.match(/safari/i)){
                browserName = "Safari";
            } else if(userAgent.match(/opr\//i)){
                browserName = "Opera";
            } else if(userAgent.match(/edg/i)){
                browserName = "Edge";
            } else{
                browserName="No browser detection";
            }


            return browserName
        },
        getMobileOperatingSystem() {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        },
        detectDeviceType() {
            let device;

            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                device = this.getMobileOperatingSystem();
            } else if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)) {
                device = 'Tablet'
            } else {
                if (navigator.platform.indexOf('Win') !== -1) {
                    device = 'Windows'
                } else if (navigator.platform.indexOf('Mac') !== -1) {
                    device = 'Mac OS'
                } else if (navigator.platform.indexOf('Linux') !== -1) {
                    device = 'Linux'
                } else {
                    device = 'Desktop'
                }
            }

            return device
        },
        async cancelOrder() {
            await this.cancelOrderAsync({orderId: this.cancelBidId, browser: this.userBrowser, device: this.userDevice});
            this.cancelBidModal = false;
            this.cancelBidId = null;
            this.getOrders()
        },
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;

            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(x => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.filteredItems.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;

                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });

                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        goToWineDetails(location = '', item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineVintageId,
                caseSize: (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId),
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: '/wine-details/' + item.wineVintageId + '/' + (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId) + '/' + (typeof item.appellation !== 'undefined' && item.appellation ? item.appellation.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.classification !== 'undefined' && item.classification) ? item.classification.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.color !== 'undefined' && item.color) ? item.color.toLowerCase() : "") + '-' + ((typeof item.producerName !== 'undefined' && item.producerName) ? item.producerName.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.producerTypeName !== 'undefined' && item.producerTypeName) ? item.producerTypeName.toLowerCase().split(' ').join('-') : "")}));
                window.scrollTo(0, 0)
            })
        },
        goToWineDetails2(item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.orders[0].caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.orders[0].caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + item.classification.toLowerCase().split(' ').join('-') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') + '-' + (item.producerTypeName !== null ? item.producerTypeName.toLowerCase().split(' ').join('-') : "")}))
                window.scrollTo(0, 0)
            })
        },
        openVirtualCellarModal() {
            this.virtualCellarModal = true
        },
        handleScroll: function () {
            if (this.scrollTopTimer) return;
            this.scrollTopTimer = setTimeout(() => {
                this.scrollTopYPos = window.scrollY;
                clearTimeout(this.scrollTopTimer);
                this.scrollTopTimer = 0;
            }, 100);
        },
        toTop: function () {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        updateFiltersData() {
            this.loadInvestmentsFilters();
            this.loadBidsOffersFilters();
            this.loadSoldWinesFilters();
            this.loadFiltersData();
        },
        loadFiltersData() {
            this.firstRowOfInvestmentsFilterObjects = [
                {
                    id: 1,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('address15'),
                    modelName: 'countryId'
                },
                {
                    id: 2,
                    type: 'select',
                    items: this.regionsList,
                    placeholder: this.$i18n.t('region'),
                    modelName: 'regionId'
                },
                {
                    id: 3,
                    type: 'select',
                    items: this.appellationsList,
                    placeholder: this.$i18n.t('appellation'),
                    modelName: 'appellationId',
                },
                {
                    id: 4,
                    type: 'select',
                    items: this.producersList,
                    placeholder: this.$i18n.t('wine'),
                    modelName: 'producerId',
                    className: 'padding-sm',
                    onChange: this.onProducerInvestmentsFieldClickHandler
                },
                {
                    id: 5,
                    type: 'select',
                    items: this.vintageMap,
                    placeholder: this.$i18n.t('vintage'),
                    modelName: 'vintageId',
                    className: 'padding-sm',
                    onChange: this.onVintageInvestmentsFieldClickHandler
                },
                {
                    id: 6,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('colour'),
                    modelName: 'colorId',
                },
            ]
            this.secondRowOfInvestmentsFilterObjects = [
                {
                    id: 1,
                    type: 'button',
                    isActive: false,
                    icon: '',
                    text: this.$i18n.t('performance'),
                    className: 'ascending',
                    onClick: this.onInvestmentsSortButtonClickHandler
                },
                {
                    id: 2,
                    type: 'button',
                    isActive: false,
                    icon: '',
                    text: this.$i18n.t('performance'),
                    className: 'descending',
                    onClick: this.onInvestmentsSortButtonClickHandler
                }
            ]
            this.firstRowOfBidsAndOffersFilterObjects = [
                {
                    id: 1,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('address15'),
                    modelName: 'countryId',
                    // onChange: this.getRegions
                },
                {
                    id: 2,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('region'),
                    modelName: 'regionId',
                    // onChange: this.getAppellationRegions
                },
                {
                    id: 3,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('appellation'),
                    modelName: 'appellationId',
                },
                {
                    id: 4,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('wine'),
                    modelName: 'producerId',
                    className: 'padding-sm',
                    onChange: this.onProducerBidsAndOffersFieldClickHandler
                },
                {
                    id: 5,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('vintage'),
                    modelName: 'vintageId',
                    className: 'padding-sm',
                    onChange: this.onVintageBidsOffersFieldClickHandler
                },
                {
                    id: 6,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('colour'),
                    modelName: 'ColourId',
                },
            ]
            this.secondRowOfBidsAndOffersFilterObjects = [
                {
                    id: 1,
                    type: 'select',
                    items: [],
                    placeholder: 'Order type',
                    modelName: 'PendingOrderType',
                },
                {
                    id: 2,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('trade-history7'),
                    modelName: 'PendingOrderStatus',
                },
            ]
            this.firstRowOfSoldWinesFilterObjects = [
                {
                    id: 1,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('address15'),
                    modelName: 'countryId',
                    // onChange: this.getRegions
                },
                {
                    id: 2,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('region'),
                    modelName: 'regionId',
                    // onChange: this.getAppellationRegions
                },
                {
                    id: 3,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('appellation'),
                    modelName: 'appellationId',
                },
                {
                    id: 4,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('wine'),
                    modelName: 'producerId',
                    className: 'padding-sm',
                    onChange: this.onProducerSoldWinesFieldClickHandler
                },
                {
                    id: 5,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('vintage'),
                    modelName: 'vintageId',
                    className: 'padding-sm'
                },
                {
                    id: 6,
                    type: 'select',
                    items: [],
                    placeholder: this.$i18n.t('colour'),
                    modelName: 'colorId',
                }
            ]
            this.secondRowOfSoldWinesFilterObjects = [
                {
                    id: 1,
                    type: 'button',
                    isActive: false,
                    icon: '',
                    text: this.$i18n.t('roi'),
                    className: 'ascending',
                    onClick: this.onSoldWinesSortButtonClickHandler
                },
                {
                    id: 2,
                    type: 'button',
                    isActive: false,
                    icon: '',
                    text: this.$i18n.t('roi'),
                    className: 'descending',
                    onClick: this.onSoldWinesSortButtonClickHandler
                }
            ]
        },
        addNewAddress() {
            this.addAdressButtonLoader = true;
            if (this.newAddress.name && this.newAddress.firstName && this.newAddress.lastName && this.newAddress.phoneNumber && this.newAddress.street && this.newAddress.postCode && this.newAddress.city) {
                if (!this.country) {
                    this.countryError = true;
                    return;
                }
                this.countryError = false;

                if (!this.addressList.length) {
                    this.newAddress.type = 3;
                    this.newAddress.isDefault = true;
                } else {
                    this.newAddress.isDefault = false;
                    if (!this.isDefaultBilling && !this.isDefaultShipping) {
                        this.newAddress.type = 4;
                    } else if (this.isDefaultBilling && !this.isDefaultShipping) {
                        this.newAddress.type = 1;
                    } else {
                        this.newAddress.type = 2;
                    }
                }

                this.newAddress.countryId = this.countries[this.country].id;
                this.newAddress.country = this.countries[this.country].value;
                this.$store.dispatch(AUser.ADD_ADDRESS, this.newAddress).then(() => {
                    this.addAdressButtonLoader = false;
                    this.addNewAddressDialog = false;
                    this.$store.dispatch(AUser.GET_ADDRESSES);

                    this.$store.dispatch(AOrders.ACTIVATE_GIFT, this.giftCode).then((res) => {
                        if (res.succeeded) {
                            this.activationSuccessful = true;
                            this.activationError = false;
                            this.loadWines();
                            this.loadWinesSummary();
                            this.loadFavWines();
                            this.getOrders();
                        } else {
                            this.activationSuccessful = false;
                            this.activationError = true;
                        }
                    }).catch(() => {
                        this.activationSuccessful = false;
                        this.activationError = true;
                    })
                })
            }
        },
        onCloseAddAddressModal() {
            this.addNewAddressDialog = false;

            if (window) {
                document.getElementsByClassName('new-address-dialog')[0].scrollTop = 0;
            }
        },
    },
    created() {
        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.loadWines();
            this.loadWinesSummary();
            this.loadNewSummary();
            this.loadSoldWinesSummary();
            this.loadSoldWinesList();
            this.loadFavWines();
            this.getOrders();
            this.setInitialTrades();
            this.getTrades({from: 0, to: 3});
            this.loadRegion(this.userData.id);
            this.loadColour(this.userData.id);
            this.loadInvestmentsFilters();
            this.loadBidsOffersFilters();
            this.loadSoldWinesFilters();
            this.loadFiltersData()
            this.$store.dispatch(AUser.GET_ADDRESSES);
            if (this.userData.firstName !== '') {
                this.newAddress.firstName = this.userData.firstName;
            }
            if (this.userData.lastName !== '') {
                this.newAddress.lastName = this.userData.lastName;
            }
            this.$nuxt.$on('onAddAddressGetCountry', (country) => {
                this.country = country
            })
            this.$nuxt.$on('onAddAddress', () => {
                this.addNewAddress()
            })
            this.$nuxt.$on('onCloseAddAddressModal', () => {
                this.onCloseAddAddressModal()
            })
        }).catch((err) => {
            this.isLogged = false;
        });
    },
    watch: {
        orders: {
            immediate: false,
            deep: true,
            handler(v) {
                if (this.orders.length) {
                    this.ordersLength = this.orders.length;
                    this.groupedOrders = {}
                    this.passedWineIds = []

                    this.orders.forEach((element) => {
                        if (this.passedWineIds.indexOf(`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`) > -1) {
                            this.groupedOrders[`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`].orders.push(element)
                        } else {
                            this.passedWineIds.push(`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`)
                            element.orders = []
                            element.orders.push(element)
                            this.groupedOrders[`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`] = element
                        }
                    })
                } else {
                    this.ordersLength = 0;
                }
            }
        },
        investmentsFilters: {
            immediate: false,
            deep: true,
            handler(v) {
                this.firstRowOfInvestmentsFilterObjects.find(el => {
                    if (el.modelName === 'countryId') {
                        el.items = [...this.investmentsFilters.countries]
                    } else if (el.modelName === 'colorId') {
                        const values = Object.values(this.investmentsFilters.colors)
                        let arr = []

                        values.map(el => {
                            arr.push({id: el.id, value: this.$i18n.t(`${el.value.toLowerCase()}`)})
                        })

                        el.items = [...arr]
                    } else if (el.modelName === 'regionId') {
                        el.items = [...this.investmentsFilters.regions]
                    } else if (el.modelName === 'appellationId') {
                        el.items = [...this.investmentsFilters.appellations]
                    } else if (el.modelName === 'vintageId') {
                        el.items = [...this.investmentsFilters.vintages]
                    } else if (el.modelName === 'producerId') {
                        el.items = [...this.investmentsFilters.producers]
                    }
                })
            }
        },
        bidsOffersFilters: {
            immediate: false,
            deep: true,
            handler(v) {
                this.firstRowOfBidsAndOffersFilterObjects.find(el => {
                    if (el.modelName === 'countryId') {
                        el.items = [...this.bidsOffersFilters.countries]
                    } else if (el.modelName === 'regionId') {
                        el.items = [...this.bidsOffersFilters.regions]
                    } else if (el.modelName === 'appellationId') {
                        el.items = [...this.bidsOffersFilters.appellations]
                    } else if (el.modelName === 'vintageId') {
                        el.items = [...this.bidsOffersFilters.vintages]
                    } else if (el.modelName === 'producerId') {
                        el.items = [...this.bidsOffersFilters.producers]
                    } else if (el.modelName === 'ColourId') {
                        const values = Object.values(this.bidsOffersFilters.colours)
                        let arr = []

                        values.map(el => {
                            arr.push({id: el.id, value: this.$i18n.t(`${el.value.toLowerCase()}`)})
                        })

                        el.items = [...arr]
                    }
                })
                this.secondRowOfBidsAndOffersFilterObjects.find(el => {
                    if (el.modelName === 'PendingOrderType') {
                        el.items = [...this.bidsOffersFilters.types]
                    } else if (el.modelName === 'PendingOrderStatus') {
                        el.items = [...this.bidsOffersFilters.statuses]
                    }
                })
            }
        },
        soldWinesFilters: {
            immediate: false,
            deep: true,
            handler(v) {
                this.firstRowOfSoldWinesFilterObjects.find(el => {
                    if (el.modelName === 'countryId') {
                        el.items = [...this.soldWinesFilters.countries]
                    } else if (el.modelName === 'regionId') {
                        el.items = [...this.soldWinesFilters.regions]
                    } else if (el.modelName === 'appellationId') {
                        el.items = [...this.soldWinesFilters.appellations]
                    } else if (el.modelName === 'vintageId') {
                        el.items = [...this.soldWinesFilters.vintages]
                    } else if (el.modelName === 'producerId') {
                        el.items = [...this.soldWinesFilters.producers]
                    } else if (el.modelName === 'colorId') {
                        const values = Object.values(this.soldWinesFilters.colours)
                        let arr = []

                        values.map(el => {
                            arr.push({id: el.id, value: this.$i18n.t(`${el.value.toLowerCase()}`)})
                        })

                        el.items = [...arr]
                    }
                })
            }
        },
        addressList: {
            immediate: true,
            deep: true,
            handler (v) {
                if(this.addressList.length >= 1) {
                    this.activateGift()
                }
            }
        }
    }
}
</script>

<style scoped>
.scrollToTopButton {
    position: fixed;
    right: 30px;
    bottom: 30px;
    cursor: pointer;
}

.info-text {
    background: #303030;
    border-radius: 6px;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    position: absolute;
    right: -45px;
    height: 65px;
    margin-top: -76px;
    white-space: pre-line;
    display: none;
}

.info-text:before {
    content: "";
    position: absolute;
    top: 100%;
    right: 75px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-top: 10px solid #303030;
    border-right: 7px solid transparent;
}

.wine-enprimeur:hover {
    cursor: pointer;
}

.wine-enprimeur:hover .info-text {
    display: flex;
    align-items: center;
}

.wine-details-head .addition-description {
    font-family: Roboto, sans-serif;
    font-weight: normal;
    font-size: 15px;
    margin-bottom: 0;
    color: #000;
}

.wine-enprimeur {
    background: #E2C477;
    text-align: center;
    width: 86px;
    height: 17px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.88);
    padding: 0;
    border-radius: 4px;
    position: relative;
}

.wine-enprimeur-bids {
    margin-right: 16px;
}

.gift-btn {
    position: absolute;
    right: 0;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    color: #004F7F;
    height: 32px;
    background: #f6f6f6;
    border-radius: 6px;
    padding: 4px 12px 6px 36px;
    top: 15px;
    z-index: 3;
}

.gift-btn svg {
    position: absolute;
    top: 0;
    left: 6px;
    fill: #004F7F;
}

.gift-btn:hover {
    cursor: pointer;
}

.gift-btn:active,
.gift-btn:focus {
    opacity: 0.7;
}

.gift-code {
    margin: 30px auto 0;
}

.bids-offers-modal h3,
.gift-modal h3,
.virtual-cellar-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
    color: rgba(0, 0, 0, 0.88);
}

.bids-offers-modal .v-card__text,
.gift-modal .v-card__text {
    padding: 8px;
}

.gift-modal p {
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.88);
    text-align: left;
}

.goto-market-btn {
    margin-top: 32px;
}

.gift-modal .btn-bid-proceed {
    width: 100%;
    min-width: 100%;
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: uppercase;
    font-weight: 700;
    padding: 0 20px !important;
    background: var(--blue);
    border-color: var(--blue);
    color: #ffffff;
    letter-spacing: 0;
}

.virtual-cellar-modal .btn-bid-proceed {
    width: 100%;
}

.btn-bid-cancel:hover {
    background-color: var(--blue);
    border-color: var(--blue);
}

.btn-login {
    background: #004f7f;
    border-color: #004f7f;
}

.bids-offers-modal,
.gift-modal,
.virtual-cellar-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.gift-modal .close-modal {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}

.bids-offers-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
    position: relative;
    top: 4px
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
    position: relative;
    top: 4px
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

.wine-details-head {
    display: flex;
    width: 100%;
    color: var(--black);
    margin-bottom: 5px;
    padding: 0 0 20px;
    position: relative;
    min-height: 150px;
}

.wine-details-head-bids {
    min-height: 50px;
    padding-bottom: 16px;
}

.wine-details-head .left-side {
    margin-right: 25px;
}

.wine-details-head .left-side .image {
    width: 44px;
}

.wine-details-head .left-side .image img {
    width: auto;
    height: 44px;
    margin: 0 auto;
    display: block;
}

.wine-details-head .right-side {
    flex: 1;
}

.new-portfolio-right-side {
    padding-left: 65px;
}

.wine-summary-wrapper {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 8px;
    margin-top: 13px;
    display: flex;
    height: 71px;
}

.wine-summary-row {
    flex: 1;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
}

.wine-summary-row:nth-child(1),
.wine-summary-row:nth-child(2),
.wine-summary-row:nth-child(3) {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.wine-summary-row:nth-child(2),
.wine-summary-row:nth-child(3),
.wine-summary-row:nth-child(4) {
    padding-left: 16px;
}

.wine-summary-row.last-child {
    max-width: 270px;
}

.wine-summary-row-title {
    color: rgba(0, 0, 0, 0.64);
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 4px;
}

.wine-summary-row-value {
    font-size: 24px;
    line-height: 29px;
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
}

.wine-summary-row-value1, .wine-summary-row-value2, .wine-summary-row-value3 {
    display: inline-block;
}

.wine-summary-row-value1 {
    margin-right: 5px;
}

.wine-summary-row-value3.up {
    width: 16px;
    height: 17px;
    background: url('../assets/price-up.png') no-repeat center;
}

.wine-summary-row-value3.down {
    width: 16px;
    height: 17px;
    background: url('../assets/price-down.png') no-repeat center;
}

.perform-btn {
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    border: 1px solid var(--light-gray);
    border-radius: 4px;
    text-align: center;
    padding: 10px;
    margin-top: 4px;
}

.perform-btn:hover {
    cursor: pointer;
}

.wine-portfolio-trades-row {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    padding: 8px 0;
    display: flex;
}

.wine-portfolio-trades-box {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    flex: 1;
}

.wine-portfolio-trades-box.last-child {
    display: flex;
    justify-content: flex-end;
    padding-right: 8px;
}

.wine-portfolio-offers-wrapper .wine-portfolio-trades-box {
    width: calc(100% / 7 - 4px);
}

.wine-portfolio-bids-wrapper .wine-portfolio-trades-box {
    width: calc(100% / 9 - 4px);
}

.wine-portfolio-trades-box-title {
    font-size: 12px;
    line-height: 15px;
    color: rgba(0, 0, 0, 0.64);
}

.wine-portfolio-trades-box-value {
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    margin-top: 8px;
}

.wine-portfolio-trades-box-value.link {
    font-weight: 600;
    color: #004F7F;
    cursor: pointer;
}

.portfolio-wine-bottle {
    position: absolute;
    left: 10px;
    top: 0;
}

.portfolio-wine-bottle-img {
    background-size: contain;
    width: 30px;
    height: 133px;
}

.wine-details-head h2 {
    color: rgba(0, 0, 0, 0.88);
    font-size: 24px;
    line-height: 29px;
}

h3 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

h4 {
    color: #707070;
    margin-top: var(--gutter);
    margin-bottom: 3px;
}

.market-btn-col {
    width: 100px;
}

.half-padding-left {
    padding-left: calc(0.5 * var(--gutter));
}

.no-padding-right {
    padding-right: 0;
}

.half-padding-right {
    padding-right: calc(0.5 * var(--gutter));
}

.trading-desk-container1 {
    height: 100%;
}

.trading-desk-container1 .v-card__text {
    height: 100%;
    padding-bottom: 0;
}

.trading-desk-table-tabs {
    padding: 0 15px;
    height: 100%;
}

.trading-desk-table-tabs .v-tabs-bar {
    background-color: #F9F9F9 !important;
}

.trading-desk-table-tabs .theme--light.v-tabs-items {
    height: calc(100% - 50px);
    background: #FFFFFF;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
}

.loading-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--semi-white);
    z-index: 10;
}

.loading-gif {
    margin: 60px auto;
    width: 200px;
    height: 200px;
}

.portfolio-table {
    margin: 0;
    background-color: transparent;
    box-shadow: none !important;
}

.wine-market-table-header-ctrls {
    height: 75px;
    padding-top: 5px;
    background: #ffffff;
    border-bottom: 1px solid #EAEEF1;
}

.winemarket-search-filter {
    width: calc(100% - 30px);
    display: inline-block;
    border-radius: 3px;
    text-indent: 48px;
    padding-left: 25px;
    background: url('../assets/search_icon.png') no-repeat 40px 16px;
}

.wine-market-wrapper {
    height: 100%;
    padding-bottom: 32px;
    position: relative;
}

.winemarket-change.negative {
    color: #da443d;
}

.winemarket-change.negative div {
    width: 20px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-left: 5px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -60px -507px;
}

.winemarket-change.positive {
    color: #3BC34F;
}

.winemarket-change.positive div {
    width: 20px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-left: 5px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -60px -456px;
}

.winemarket-winecolor-img {
    width: 20px;
    height: 45px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -17px -544px;
    position: relative;
}

.winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.whitewine {
    background: url('../assets/sprite-web.png') no-repeat -17px -444px;
    background-size: contain;
}

.winecolor-tooltip {
    width: 80px;
    height: 25px;
    color: #182730;
    font-size: 13px;
    font-weight: 400;
    top: -15px;
    left: 8px;
    position: relative;
    background: #f9f9f9;
    border-radius: 5px;
    text-align: center;
    line-height: 25px;
    -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    display: none;
}

.winemarket-winecolor-img:hover .winecolor-tooltip {
    display: block;
}

.v-data-table tr:hover,
.v-data-table td:hover {
    cursor: pointer;
}

.order-success-text {
    text-align: center;
}

.close-order-success-modal {
    margin: 0 auto;
}

.show-hide-ctrl:hover {
    cursor: pointer;
    background-position-x: -41px;
}

.country-fr {
    background: url('../assets/france.png') no-repeat center;
    width: 30px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-right: 5px;
    position: relative;
}

.wine-star {
    width: 20px;
    height: 20px;
    background: url('../assets/star-not-selected.svg') no-repeat center;
    background-size: contain;
    display: block;
}

.wine-star:focus,
.wine-star:active {
    outline: none;
}

.wine-star.active,
.wine-star:hover {
    background: url('../assets/star-selected.svg') no-repeat center;
    background-size: contain;
}

.wine-star.active:hover {
    opacity: 0.8;
}

.wine-details-head h2:hover {
    color: var(--blue);
    cursor: pointer;
}

.portfolio-wrapper .portfolio-row {
    margin-top: 30px;
    width: 100%;
}

.portfolio-wrapper .v-window.v-item-group.theme--light {
    flex: 1 1 auto;
    padding: 0 !important;
    width: 100%;
}

.portfolio-wrapper .portfolio-row .portfolio-row-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
}

.second-row .status {
    display: flex;
    align-items: center;
}

.second-row .status .chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 0 6px;
    height: 18px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
}

.second-row .status .chip > span {
    display: block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 1px;
}

.second-row .status .chip.bid {
    background-color: #004F7F;
    color: #FFF;
    width: 50px;
    height: 17px;
    padding: 0;
    text-align: center;
    display: inline-block;
    margin-right: 16px;
}

.second-row .status .chip.offer {
    color: #004F7F;
    border: 1px solid #004F7F;
    height: 17px;
    padding: 0 5px;
    text-align: center;
    display: inline-block;
    margin-right: 16px;
}

.second-row .status .chip.cancelled {
    border-color: rgba(213, 57, 79, 1);
    color: rgba(0, 0, 0, 0.88);
}

.second-row .status .chip.cancelled > span {
    background-color: rgba(213, 57, 79, 1);
}

.second-row .status .chip.expired {
    color: rgba(0, 0, 0, 0.88);
    border: 1px solid rgba(0, 0, 0, 0.38);
}

.second-row .status .chip.expired > span {
    background-color: rgba(0, 0, 0, 0.88);
}

.second-row .status .chip.active {
    color: rgba(0, 0, 0, 0.88);
    border: 1px solid #018671;
}

.second-row .status .chip.active > span {
    background-color: #018671;
}

.portfolio-wrapper .portfolio-row .portfolio-row-content {
    background-color: #FFF;
    border-radius: 8px;
    padding: 16px;
    padding-bottom: 8px;
}

.market-btn {
    width: 130px;
    font-weight: 700;
    text-align: center;
    font-size: 16px;
    line-height: 30px;
    height: 46px;
}

.market-btn:hover {
    background-color: var(--blue);
    border-color: var(--blue);
}

.portfolio-wrapper .second-row {
    font-weight: 300;
    line-height: 20px;
    color: var(--black);
    display: flex;
    align-items: center;
    margin-top: 5px;
}

.second-row.second-row-bids {
    margin: 5px 0 0 0;
}

.last-trade {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.88);
}

.portfolio-wrapper .last-trade-el {
    display: inline-block;
}

.portfolio-wrapper .my-investments {
    width: 100%;
    height: 76px;
    background-color: #E2C477;
    padding: 16px 0;
    display: flex;
    border-radius: 8px;
}

.portfolio-wrapper .my-investments .investments-item {
    text-align: right;
    border-right: 1px solid #FADF95;
    padding-right: 15px;
    padding-left: 20px;
    flex: 1;
}

.portfolio-wrapper .my-investments .investments-item.total-gain {
    border-right: 0;
}

.portfolio-wrapper .my-investments .investments-item.investment-item-performance {
    display: flex;
    flex-direction: column;
    flex-basis: 12%;
}

.portfolio-wrapper .my-investments .investments-item .rate-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.portfolio-wrapper .my-investments .investments-label {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    color: #ffffff;
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 0;
}

.portfolio-wrapper .my-investments .bold {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 24px;
    line-height: 29px;
    color: #fff;
    font-weight: 600;
}

.portfolio-wrapper .my-investments .bold,
.portfolio-wrapper .my-investments .regular,
.portfolio-wrapper .my-investments .performance {
    display: inline-block;
}

.portfolio-wrapper .my-investments .performance {
    margin-left: 5px;
}

.portfolio-wrapper .my-investments .regular {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 24px;
    line-height: 29px;
    color: #ffffff;
    margin-left: 16px;
}

.performance.up {
    background: url('../assets/price-upw.png') no-repeat center;
    width: 16px;
    height: 17px;
}

.theme--light.v-data-table.default-table.table-two-rows tbody tr td {
    height: 35px
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table tbody tr td {
    height: 35px;
}
</style>

<style>
.gift-modal .v-input .v-label {
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    top: -1px;
}

.gift-modal .v-input .v-label.primary--text {
    color: var(--blue) !important;
    caret-color: var(--blue) !important;
}

.gift-modal .gift-code .v-text-field input {
    padding: 8px;
}

.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

.offers-table .hyperlink-td,
.bids-table .hyperlink-td {
    text-transform: uppercase;
    float: right;
    color: var(--blue)
}

.offers-table .hyperlink-td:hover,
.bids-table .hyperlink-td:hover {
    color: var(--blue);
    text-decoration: underline;
}

.footer-info-text div {
    display: inline-block;
    margin-right: 25px;
}

.portfolio-wrapper .theme--light.v-data-table tbody tr td .dots {
    display: inline-block;
    width: 8px;
    height: 18px;
    margin: 0;
    background: url('../assets/dots-only-for-example.png') no-repeat center;
    background-size: contain;
    cursor: pointer;
    position: relative;
    top: 2px;
}

.portfolio-wrapper .theme--light.v-data-table thead tr th.gain-th:after {
    content: '';
    width: 15px;
    height: 15px;
    background: url('../assets/info-icon-for-example.png') no-repeat center;
    position: absolute;
    right: -15px;
    top: 15px;
    background-size: cover;
}

.portfolio-wrapper .v-data-table {
    box-shadow: none !important;
    width: 100%;
}

.portfolio-wrapper .last-trade-el-class {
    margin: 0 calc(1.5 * var(--gutter));
}

.portfolio-wrapper .winemarket-winecolor-img {
    display: inline-block;
    width: 20px;
    height: 16px;
    position: relative;
    margin: 0 0 0 calc(1.5 * var(--gutter));
    background: url('../assets/rose.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .winemarket-winecolor-img.whitewine {
    background: url('../assets/white.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .wine-details-img {
    width: 30px;
    height: 19px;
    border: 1px solid #DEE2E4;
    position: relative;
    margin-right: 5px;
}

.portfolio-wrapper .wine-details-img + .country-name {
    margin-right: 20px;
}

.portfolio-wrapper .wine-details-region {
    max-width: var(--container-width);
    display: flex;
    font-family: Montserrat, sans-serif;
}

.portfolio-wrapper .theme--light.v-data-table.v-data-table--fixed-header.default-table thead th {
    padding-bottom: 0;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tabs-bar {
    max-width: 100%;
    background: var(--semi-white);
    padding: 0;
    height: 48px;
}

.portfolio-tabs .v-tabs-slider {
    background-color: transparent;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab {
    background: #F5F6F5;
    text-transform: capitalize;
    color: rgba(0, 0, 0, .64);
    font-weight: 700;
    font-size: calc(var(--fs-base) - 2px);
    min-width: 120px;
    padding: 0 16px;
    text-transform: uppercase;
    border-bottom: 1px solid #B9BAB9;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab.v-tab--active {
    border: 0;
    background: var(--semi-white);
    border-bottom: 4px solid var(--blue);
    position: relative;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab.v-tab--active:after {
    content: '';
    width: 100%;
    position: absolute;
    background: #fff;
    height: 1px;
    bottom: -1px;
    left: 0;
}

.my-profile-card .my-profile-vertical-tabs .portfolio-tabs .v-slide-group__content .v-tabs-slider-wrapper {
    border-bottom: 1px solid #B9BAB9;
    display: block;
    width: 100% !important;
}

.theme--light.v-data-table .v-data-table-header th.sortable[aria-sort="none"] .v-icon {
    display: none;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table thead tr th {
    color: rgba(0, 0, 0, 0.64) !important;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table {
    font-family: Montserrat, sans-serif;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table tbody tr {
    border: 0;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table tbody tr td {
    font-weight: 700;
    font-size: 14px;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table tbody tr td:first-child {
    font-weight: 400;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table thead th:hover {
    color: var(--blue) !important;
    cursor: default;
}

.my-profile-vertical-tabs .portfolio-tabs .v-window.v-item-group.theme--light {
    padding-left: 0;
}

.no-investments-wrapper {
    text-align: center;
    margin-top: 20px;
}

.no-investments-wrapper svg {
    margin: 0 auto;
}

.no-investments-wrapper h2 {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 30px;
}

.no-investments-wrapper a {
    text-decoration: none;
}

.no-investments-wrapper .btn-primary {
    background-color: var(--blue) !important;
    border-radius: 8px;
    padding: 12px 16px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: var(--white);
    letter-spacing: 0;
    border: 0;
    height: 41px !important;
    text-decoration: none;
}
</style>
